import React from 'react';
import {
  CanonicalContact,
  ContactRole,
} from '../helpers/contactShape';
import { GroupedContacts } from '../helpers/groupByRole';
import ContactSearchAndFilters from './ContactSearchAndFilters';
import ContactRoleGroup from './ContactRoleGroup';
import ContactRoleGroupSkeleton from './ContactRoleGroupSkeleton';
import './ContactPickerPanel.scss';

const SKELETON_GROUP_COUNT: number = 3;

interface ContactPickerPanelProps {
  isLoading: boolean;
  groupedResults: GroupedContacts[];
  availableCategories: string[];
  availableRoles: ContactRole[];
  searchTerm: string;
  selectedRoles: ContactRole[];
  selectedCategories: string[];
  subtitleVariant: 'role-only' | 'role-and-services';
  onChangeSearchTerm: (term: string) => void;
  onChangeSelectedRoles: (roles: ContactRole[]) => void;
  onChangeSelectedCategories: (categories: string[]) => void;
  onSelectContact: (contact: CanonicalContact) => void;
}

const ContactPickerPanel = ({
  isLoading,
  groupedResults,
  availableCategories,
  availableRoles,
  searchTerm,
  selectedRoles,
  selectedCategories,
  subtitleVariant,
  onChangeSearchTerm,
  onChangeSelectedRoles,
  onChangeSelectedCategories,
  onSelectContact,
}: ContactPickerPanelProps) => {
  return (
    <div className="contact-picker-panel">
      <ContactSearchAndFilters
        searchTerm={searchTerm}
        selectedRoles={selectedRoles}
        selectedCategories={selectedCategories}
        availableCategories={availableCategories}
        availableRoles={availableRoles}
        onChangeSearchTerm={onChangeSearchTerm}
        onChangeSelectedRoles={onChangeSelectedRoles}
        onChangeSelectedCategories={onChangeSelectedCategories}
      />

      <div className="groups">
        {isLoading ? (
          Array.from({ length: SKELETON_GROUP_COUNT }, (_, index: number) => (
            <ContactRoleGroupSkeleton key={`group-skeleton-${index}`} />
          ))
        ) : groupedResults.length === 0 ? (
          <div className="empty">No contacts match these filters.</div>
        ) : (
          groupedResults.map((group: GroupedContacts) => (
            <ContactRoleGroup
              key={group.role}
              group={group}
              onSelect={onSelectContact}
              subtitleVariant={subtitleVariant}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default ContactPickerPanel;
